import React from "react";
import { Container } from "./style";
import { LeftOutlined } from "@ant-design/icons";
import StatusBar from "../../assets/app_status_bar.png";
import Tabbar from "../../assets/app_tabbar.png";

export default function MockPhone(props) {
  const { isFixed, ...restProps } = props;
  // Prevent unused variable warning
  void restProps;
  return (
    <Container isFixed={isFixed}>
      <div className="mock-phone">
        <img src={StatusBar} className="mock-status-bar" alt="Status bar" />
        {props.title && (
          <div className="mock-header">
            <div className="mock-back">
              <LeftOutlined />
            </div>
            <div className="mock-title">{props.title}</div>
          </div>
        )}
        <div className="mock-children">{props.children}</div>
        {props.showTabbar && <img src={Tabbar} className="mock-tabbar" alt="Tab bar" />}
      </div>
    </Container>
  );
}
